/**
 * @generated SignedSource<<5bac7c75906014a76802d9b30c125ce4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CampaignsCampaigns$data = {
  readonly campaigns: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"CampaignBigCampaign" | "CampaignCampaign">;
      };
    }>;
  };
  readonly " $fragmentType": "CampaignsCampaigns";
};
export type CampaignsCampaigns$key = {
  readonly " $data"?: CampaignsCampaigns$data;
  readonly " $fragmentSpreads": FragmentRefs<"CampaignsCampaigns">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "campaigns"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "selectedCategories"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "selectedHasMoney"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "selectedHasProduct"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "selectedPrefectures"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "selectedSns"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "tab"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": require('./CampaignsQuery.graphql')
    }
  },
  "name": "CampaignsCampaigns",
  "selections": [
    {
      "alias": "campaigns",
      "args": [
        {
          "kind": "Variable",
          "name": "selectedCategories",
          "variableName": "selectedCategories"
        },
        {
          "kind": "Variable",
          "name": "selectedHasMoney",
          "variableName": "selectedHasMoney"
        },
        {
          "kind": "Variable",
          "name": "selectedHasProduct",
          "variableName": "selectedHasProduct"
        },
        {
          "kind": "Variable",
          "name": "selectedPrefectures",
          "variableName": "selectedPrefectures"
        },
        {
          "kind": "Variable",
          "name": "selectedSns",
          "variableName": "selectedSns"
        },
        {
          "kind": "Variable",
          "name": "tab",
          "variableName": "tab"
        }
      ],
      "concreteType": "CampaignConnection",
      "kind": "LinkedField",
      "name": "__CampaignsList_campaigns_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CampaignEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Campaign",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "CampaignBigCampaign"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "CampaignCampaign"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "e756eea6bd1643881df1ba5735f21ab1";

export default node;
